import classNames from 'classnames'

import type { LinkType } from 'types'

import GlobePinIcon from 'ui-component-library/icons/globe-pin.svg'
import Link from 'content-components/_Primatives/Link'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

const GOOGLE_MAPS = 'https://www.google.com/maps/search/?api=1&query='

type Props = {
  mapLinkText: string
  location: {
    address: string
    city: string
    country: string
    postalCode: string
    state?: string
  }
  name: string
  websiteLink?: LinkType
}

function LocationCard({ location, name, websiteLink, mapLinkText }: Props) {
  const { address, state, city, postalCode, country } = location

  const addressLine2Parts = [`${city},`, state, postalCode]
    .filter(Boolean)
    .join(' ')
  const locationParts = [address, addressLine2Parts, country]
  const mapQueryParams = encodeURIComponent(locationParts.join(', '))

  const addressText = locationParts.join(' \n ')
  const mapLinkURL = `${GOOGLE_MAPS}${mapQueryParams}`

  return (
    <div className={style.wrapper}>
      <GlobePinIcon aria-hidden className={style.globeIcon} />
      <Paragraph className={style.affiliateName} small>
        {name}
      </Paragraph>
      <Paragraph className={classNames(style.paragraph, style.address)} small>
        {addressText}
      </Paragraph>
      {websiteLink && (
        <Link className={style.link} url={websiteLink.url}>
          {websiteLink.text}
        </Link>
      )}
      <Link className={style.link} url={mapLinkURL}>
        {mapLinkText}
      </Link>
    </div>
  )
}

export default LocationCard
